import { T } from "@/locales";
import { getLodop } from "@/utils/LodopFuncs";
import JsBarcode from "jsbarcode";

export default function printOrder(items, printConfig) {
  const LODOP = getLodop();
  LODOP.PRINT_INIT("ReceiptOrder");
  LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm");
  LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
  LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);

  for (const item of items) {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, item.number, {
      format: "CODE128",
      width: 2,
      height: 35,
      displayValue: true,
      background: "#ffffff",
      lineColor: "#000000",
    });
    const barcodeBase64 = canvas.toDataURL();

    console.log(item.receipt_material_items);
    const materialItems = sortTableData(printConfig.tableSortType, printConfig.tableSortField, item.receipt_material_items);
    const perPageRows = printConfig.tableRows ?? 10;
    const pageCount = Math.ceil(materialItems.length / perPageRows);
    for (let pageIndex = 1; pageIndex <= pageCount; pageIndex++) {
      // Header
      const headerFields = (printConfig.headerFields ?? []).map((fieldName) => {
        const fieldItem = getHeaderField(item, fieldName);
        if (fieldItem) {
          return `
            <div style="display: inline-block; width: 33.33%;">
              <div style="display: flex; justify-content: space-between; margin-top: 4px;">
                <div style="flex-grow: 0; padding: 0 8px; white-space: nowrap">${fieldItem.label}:</div>
                <div style="flex-grow: 1;">${fieldItem.value}</div>
              </div>
            </div>`;
        }
        return null;
      });

      // Table
      const pageMaterialItems = materialItems.slice((pageIndex - 1) * perPageRows, pageIndex * perPageRows);
      const tableHeader = (printConfig.tableFields ?? []).map((fieldName) => `<td>${getTablerFieldLabel(fieldName)}</td>`);
      const tableRows = pageMaterialItems.map((item) => {
        const tableCols = (printConfig.tableFields ?? []).map(
          (fieldName) => `<td>${getTablerFieldValue(item, fieldName)}</td>`
        );

        return `<tr>${tableCols.join("")}</tr>`;
      });

      const tableTotalCols = (printConfig.tableFields ?? [])
        .slice(1)
        .map((fieldName) => getTableTotalValue(materialItems, fieldName));

      const pageContent = `
        <div style="width: 210mm; height: 297mm; position: relative;">
          <div style="padding: 16px 16px 0 16px; height: 100%;">
            <div style="font-size: 36px; text-align: center;">
              <span>${printConfig.title ?? ""}</span>
            </div>

            <div style="margin-top: 8px; text-align: right;">
              <img src="${barcodeBase64}" />
            </div>

            <div style="margin-top: 8px; padding: 0 16px; display: flex; flex-wrap: wrap;">
              ${headerFields.filter((value) => value).join("")}
            </div>

            <div style="margin-top: 16px; font-size: 14px;">
              <table border="1" cellspacing="0" style="width: 100%; text-align: center;">
                <tr>${tableHeader.join("")}</tr>
                ${tableRows.join("")}
                <tr>
                  <td>合计:</td>
                  ${tableTotalCols.join("")}
                </tr>
              </table>
            </div>
          
            <div style="margin-top: ${printConfig.tableMarginBottom}px; padding: 0 16px; display: flex;">
              <div style="width: 50%; 
                text-align: ${printConfig.leftTextAlign ?? "left"};
                font-size: ${printConfig.leftTextFontSize ?? 12};
                font-weight: ${printConfig.leftTextFontWeight ? "bold" : "normal"};
                font-style: ${printConfig.leftTextFontItalic ? "italic" : "normal"};"
              >${printConfig.leftTextContent ?? ""}</div>
              <div style="width: 50%;
                text-align: ${printConfig.rightTextAlign ?? "left"};
                font-size: ${printConfig.rightTextFontSize ?? 12};
                font-weight: ${printConfig.rightTextFontWeight ? "bold" : "normal"};
                font-style: ${printConfig.rightTextFontItalic ? "italic" : "normal"};"
              >${printConfig.rightTextContent ?? ""}</div>
            </div>
            <div style="position: absolute;
              bottom: ${printConfig.bottomTextBottom + 24}px;
              left: 0; right: 0; padding: 0 16px;">
              <div style="width: 100%;
                text-align: ${printConfig.bottomTextAlign ?? "left"};
                font-size: ${printConfig.bottomTextFontSize ?? 12};
                font-weight: ${printConfig.bottomTextFontWeight ? "bold" : "normal"};
                font-style: ${printConfig.bottomTextFontItalic ? "italic" : "normal"};"
              >${printConfig.bottomTextContent ?? ""}</div>
            </div>

            <div style="position: absolute; bottom: 0; left: 0; right: 0;">
              <div style="width: 100%; text-align: center;">第 ${pageIndex} 页 / 共 ${pageCount} 页</div>
            </div>
          </div>  
        </div>`;

      LODOP.NewPage();
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", pageContent);
    }
  }

  LODOP.PREVIEW();
}

function getHeaderField(item, fieldName) {
  switch (fieldName) {
    case "warehouse":
      return { label: T("仓库"), value: item.warehouse_item.name ?? "" };
    case "client":
      return { label: T("货主"), value: item.client_item.name ?? "" };
    case "counterparty":
      return { label: T("往来单位"), value: item.counterparty_item?.name ?? "" };
    case "external_number":
      return { label: T("往来单位单号"), value: item.external_number ?? "" };
    case "arrival_date":
      return { label: T("预计到货日"), value: item.arrival_date ?? "" };
    case "remark":
      return { label: T("备注"), value: item.remark ?? "" };
    case "creator":
      return { label: T("创建人"), value: item.creator_item.name ?? "" };
    case "create_time":
      return { label: T("创建时间"), value: item.create_time ?? "" };
    default:
      return null;
  }
}

function sortTableData(sortType, sortField, items) {
  items.sort(function (a, b) {
    if (a[sortField] < b[sortField]) {
      return sortType === "positive" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return sortType === "positive" ? 1 : -1;
    }
    return 0;
  });

  return items;
}

function getTablerFieldLabel(fieldName) {
  switch (fieldName) {
    case "material_number":
      return T("货品编号");
    case "material_name":
      return T("货品名称");
    case "material_barcode":
      return T("货品条码");
    case "total_quantity":
      return T("数量");
    case "length":
      return T("长(cm)");
    case "width":
      return T("宽(cm)");
    case "height":
      return T("高(cm)");
    case "volume":
      return T("体积(m³)");
    case "weight":
      return T("重量(kg)");
    case "total_volume":
      return T("总体积(m³)");
    case "total_weight":
      return T("总重量(kg)");
    case "spec":
      return T("规格");
    case "unit":
      return T("单位");
    case "batch_number":
      return T("批次编号");
    default:
      return "";
  }
}

function getTablerFieldValue(item, fieldName) {
  switch (fieldName) {
    case "material_number":
      return item.material_item.number ?? "";
    case "material_name":
      return item.material_item.name ?? "";
    case "material_barcode":
      return item.material_item.barcode ?? "";
    case "total_quantity":
      return item.total_quantity ?? "";
    case "length":
      return item.material_item.length ?? "";
    case "width":
      return item.material_item.width ?? "";
    case "height":
      return item.material_item.height ?? "";
    case "volume":
      return item.material_item.volume ?? "";
    case "weight":
      return item.material_item.weight ?? "";
    case "total_volume":
      return ((item.total_quantity ?? 0) * (item.material_item.volume ?? 0)).toFixed(2);
    case "total_weight":
      return ((item.total_quantity ?? 0) * (item.material_item.weight ?? 0)).toFixed(2);
    case "spec":
      return item.material_item.spec ?? "";
    case "unit":
      return item.material_item.unit ?? "";
    case "batch_number":
      return item.batch_number ?? "";
    default:
      return "";
  }
}

function getTableTotalValue(items, fieldName) {
  switch (fieldName) {
    case "total_quantity":
      return `<td>${items.reduce((accumulator, currentItem) => accumulator + currentItem.total_quantity ?? 0, 0)}</td>`;
    case "total_volume":
      return `<td>${items.reduce(
        (accumulator, currentItem) =>
          accumulator + ((currentItem.total_quantity ?? 0) * (currentItem.material_item.volume ?? 0)).toFixed(2),
        0
      )}</td>`;
    case "total_weight":
      return `<td>${items.reduce(
        (accumulator, currentItem) =>
          accumulator + ((currentItem.total_quantity ?? 0) * (currentItem.material_item.weight ?? 0)).toFixed(2),
        0
      )}</td>`;
    default:
      return "<td></td>";
  }
}
